

/// <reference path="LegalEntityPaymentInstallment.ts" />

// Generated class ClientPaymentInstallment_ManagedObject

class ClientPaymentInstallment_ManagedObject extends LegalEntityPaymentInstallment
{
}
